<div
  id="divleftmenu"
  class="iso-left-menu"
  [ngClass]="isMenuExpanded ? 'iso-left-menu-expanded' : 'collapsed-menu'"
>
  <div id="divleftmenuopen" class="iso-left-menu-open" (click)="toggleMenu()">
    <span
      [matTooltip]="isMenuExpanded ? 'Collapse Sidebar' : 'Expand Sidebar'"
      [matTooltipPosition]="'right'"
    >
      <i class="material-icons iso-material-icons white">arrow_forward</i>
    </span>
  </div>
  <div
    id="divleftmenuitems"
    class="menuitems"
    *ngIf="isClientSelected"
    @slideDown
  >
    <ng-container
      *ngTemplateOutlet="menuList; context: { $implicit: menuItems }"
    ></ng-container>
  </div>
  <div
    id="divleftmenuitemsnoclient"
    class="menuitems"
    *ngIf="!isClientSelected"
    @slideDown
  >
    <ng-container
      *ngTemplateOutlet="menuList; context: { $implicit: noClientMenuItems }"
    ></ng-container>
  </div>
</div>

<ng-template #menuList let-items>
  <ul class="iso-left-menu-icons" *ngIf="!isMenuExpanded">
    <li
      placement="right"
      *ngFor="let menuItem of items"
      (click)="onMenuItemClick(menuItem)"
    >
      <div
        class="divIcon"
        #tooltip="matTooltip"
        matTooltip="{{ menuItem.text }}"
        [matTooltipPosition]="'right'"
      >
        <i class="material-icons iso-material-icons">{{ menuItem.icon }}</i>
      </div>
    </li>
  </ul>
  <ul
    class="iso-left-menu-icons"
    *ngIf="isMenuExpanded"
    style="width: 225px; transition: 0.5s"
  >
    <li
      placement="right"
      *ngFor="let menuItem of items"
      (click)="onMenuItemClick(menuItem)"
    >
      <div class="divIcon">
        <i class="material-icons iso-material-icons">{{ menuItem.icon }}</i>
      </div>
      <span class="showtext">{{ menuItem.text }}</span>
    </li>
  </ul>
</ng-template>
